import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'common.titles.shippingMethod',
    defaultMessage: 'Shipping Method',
  },
  notice: {
    id: 'components.Delivery.notice',
    defaultMessage:
      'Orders placed after 11 a.m. (USA: PST, Europe: CET) Monday through Friday are processed on the next business day. Please note that there is no delivery on Saturdays or Sundays.',
  },
  continue: {
    id: 'common.buttons.continue',
    defaultMessage: 'Continue',
  },
  back: {
    id: 'components.Delivery.back',
    defaultMessage: 'Back to edit address',
  },
  error: {
    id: 'components.ErrorBoundary.headline',
    defaultMessage: 'Oops, something went wrong here',
  },
});
